import React from 'react';

import type { ResourceIconName } from 'src/api';

import { ResourceCardIconsMapping } from './constants';

interface ResourceCardIconProps {
  iconName: ResourceIconName;
}

export const ResourceCardIcon: React.FC<ResourceCardIconProps> = ({ iconName }) => {
  const Icon = ResourceCardIconsMapping[iconName];
  return <Icon sx={{ width: '44px', height: '44px' }} color="action" />;
};
